// extracted by mini-css-extract-plugin
export default {"path":"yIGipsJvRwlSRX55IPhQ","view-file":"R4SrMTRCLI0RdU60HLBr"};